export const _helper = {
  dateFormate,
  defaultDate,
  stringToDate,
  compareDate,
  lastCheckDateFromCurrent,
  extractYearMonthDay,
  DateFormateOrganization,
};

function dateFormate(date) {
  const dateFormat = sessionStorage.getItem("df");
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  switch (dateFormat) {
    case "dd.MM.yyyy":
      return day + "." + month + "." + year;
    case "MM.dd.yyyy":
      return month + "." + day + "." + year;
    case "yyyy.MM.dd":
      return year + "." + month + "." + day;
    case "dd/MM/yyyy":
      return day + "/" + month + "/" + year;
    case "MM/dd/yyyy":
      return month + "/" + day + "/" + year;
  }
}

function defaultDate(days) {
  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - days);

  return currentDate;
}

function stringToDate(_date) {
  const dateComponents = _date.split(".");
  const day = parseInt(dateComponents[0]);
  const month = parseInt(dateComponents[1]) - 1;
  const year = parseInt(dateComponents[2]);
  const dateObject = new Date(year, month, day);
  return dateObject;
}

function compareDate(date1, date2) {
  const dateFormat = sessionStorage.getItem("df");
  const day2 = date2.getDate();
  const month2 = date2.getMonth() + 1;
  const year2 = date2.getFullYear();
  switch (dateFormat) {
    case "dd.MM.yyyy":
      const [day1, month1, year1] = date1.split(".");
      const formattedDate1 = `${year1}-${month1}-${day1}`;
      const formattedDate2 = `${year2}-${month2}-${day2}`;

      const _date1 = new Date(formattedDate1);
      const _date2 = new Date(formattedDate2);
      _date1.setHours(0, 0, 0, 0);
      _date2.setHours(0, 0, 0, 0);
      const timestamp1 = Math.floor(_date1.getTime() / 1000);
      const timestamp2 = Math.floor(_date2.getTime() / 1000);
      return { timestamp1, timestamp2 };
  }
}

function lastCheckDateFromCurrent(_noDays) {
  const currentDate = new Date();
  const resultDate = new Date(currentDate);
  resultDate.setDate(resultDate.getDate() - _noDays);
  return returnSepartorWithAppendingZero(resultDate);
}

export function extractYearMonthDay(dateValue) {
  if (dateValue) {
    const parts = dateValue.match(/(\d+)/g);
    const format = sessionStorage.getItem("df").toUpperCase();
    let day, month, year;

    if (
      format === "DD.MM.YYYY" ||
      format === "DD/MM/YYYY" ||
      format === "DD-MM-YYYY"
    ) {
      day = parts[0];
      month = parts[1];
      year = parts[2];
    } else if (
      format === "MM.DD.YYYY" ||
      format === "MM/DD/YYYY" ||
      format === "MM-DD-YYYY"
    ) {
      month = parts[0];
      day = parts[1];
      year = parts[2];
    } else if (
      format === "YYYY.MM.DD" ||
      format === "YYYY/MM/DD" ||
      format === "YYYY-MM-DD"
    ) {
      year = parts[0];
      month = parts[1];
      day = parts[2];
    }

    return {
      day: String(parseInt(day)).padStart(2, "0"),
      month: String(parseInt(month)).padStart(2, "0"),
      year: String(year),
    };
  }
  return undefined;
}

function returnSepartorWithAppendingZero(date) {
  const dateFormat = sessionStorage.getItem("df");
  const day = String(parseInt(date.getDate())).padStart(2, "0");
  const month = String(parseInt(date.getMonth() + 1)).padStart(2, "0");
  const year = date.getFullYear();
  switch (dateFormat) {
    case "dd.MM.yyyy":
      return day + "." + month + "." + year;
    case "MM.dd.yyyy":
      return month + "." + day + "." + year;
    case "yyyy.MM.dd":
      return year + "." + month + "." + day;
    case "dd/MM/yyyy":
      return day + "/" + month + "/" + year;
    case "MM/dd/yyyy":
      return month + "/" + day + "/" + year;
  }
}

function DateFormateOrganization(isFormate = false) {
  const dateFormat = sessionStorage.getItem("df");
  switch (dateFormat) {
    case "dd.MM.yyyy":
      return isFormate ? "dd.MM.yyyy" : "DD.MM.YYYY";
    case "MM.dd.yyyy":
      return isFormate ? "MM.dd.yyyy" : "MM.DD.YYYY";
    case "yyyy.MM.dd":
      return isFormate ? "yyyy.MM.dd" : "YYYY.MM.DD";
    case "dd/MM/yyyy":
      return isFormate ? "dd/MM/yyyy" : "DD/MM/YYYY";
    case "MM/dd/yyyy":
      return isFormate ? "MM/dd/yyyy" : "MM/DD/YYYY";
  }
}
